export const INTERCOM_HELP_LAUNCHER_ID = 'pga-intercom-help'
export const INTERCOM_HELP_LAUNCHER_SELECTOR = `#${INTERCOM_HELP_LAUNCHER_ID}`

export const BASE_INTERCOM_BOOT_OPTIONS = {
  hideDefaultLauncher: true,
  customLauncherSelector: INTERCOM_HELP_LAUNCHER_SELECTOR,
}

let defaultLauncherVisibilityRequestCount = 0

export const getCurrentIntercomBootOptions = () => ({
  ...BASE_INTERCOM_BOOT_OPTIONS,
  hideDefaultLauncher: defaultLauncherVisibilityRequestCount === 0,
})

export const requestDefaultLauncherVisibility = () => {
  defaultLauncherVisibilityRequestCount += 1

  return () => {
    defaultLauncherVisibilityRequestCount = Math.max(
      0,
      defaultLauncherVisibilityRequestCount - 1,
    )
  }
}

export const __resetIntercomLauncherVisibilityForTests = () => {
  defaultLauncherVisibilityRequestCount = 0
}
